export default __webpack_public_path__ + "static/media/MesoF.1acffe6a.svg";